import { render, staticRenderFns } from "./collageSesionAuth.vue?vue&type=template&id=56f9e7f3"
import script from "./collageSesionAuth.vue?vue&type=script&lang=js"
export * from "./collageSesionAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports